import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from './StateProvider.js';
import axios from 'axios';
import configData from './Config';
import { getQuantity } from './Utils/items.js';
import { getPermission } from './Utils/permissions.js';
import StatementAccount from './StatementAccount.js';
import ReactToPrint from 'react-to-print';
import Select from './Components/select.js';

import { unitsofmeasurement, itemtypes } from './Utils/items.js';

import Title from './Title.js';

import './Items.css';

function Items({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    const [search, setSearch] = useState('');
    const [filtereditems, setFiltereditems] = useState([]);

    useEffect(() => {
        const filtered = project.items.filter((items) =>
            items.name.toLowerCase().includes(search.toLowerCase()) ||
            items.code.toLowerCase().includes(search.toLowerCase())
        );

        setFiltereditems(filtered);
    }, [project, search]);

    const handleCloseModal = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const addButton = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AddItem />, modaltype: 'small', modaltitle: 'Add Item' }));
    }

    const editButton = (item) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditItem item={item} />, modaltype: 'small', modaltitle: 'Edit Item' }));
    }

    const viewButton = (item) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewItem item={item} />, modaltype: 'small', modaltitle: 'View Item' }));
    }

    const removeButton = (item) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <RemoveItem item={item} />, modaltype: 'small', modaltitle: 'Remove Item' }));
    }

    const handleAccountStatement = (type, account) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <StatementAccount state={state} setState={setState} type={type} account={account} />, modaltype: 'large', modaltitle: 'Statement of Account' }));
    }

    const viewCategories = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewCategories />, modaltype: 'large', modaltitle: 'Categories' }));
    }

    const viewModifiers = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewModifiers />, modaltype: 'large', modaltitle: 'Modifiers' }));
    }

    const exportPage = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ExportPage />, modaltype: 'small', modaltitle: 'Export' }));
    }

    const importPage = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ImportPage />, modaltype: 'small', modaltitle: 'Export' }));
    }

    function ExportPage() {
        const [result, setResult] = useState('');

        useEffect(() => {
            if (!project || !project.items || project.items.length === 0) {
                setResult('No data to export');
                return;
            }

            const importedContent = JSON.stringify(project.items, null, 2);

            navigator.clipboard.writeText(importedContent)
                .then(() => setResult('Data copied to clipboard'))
                .catch(err => setResult('Error copying data to clipboard: ', err));
        }, []);

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            {result}
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function ImportPage() {
        const [importText, setImportText] = useState('');
        const [newEntries, setNewEntries] = useState([]);
        const [importType, setImporttype] = useState('');

        const [loading, setLoading] = useState(false);
        const [result, setResult] = useState('');

        useEffect(() => {
            if (!importText) {
                setResult('');
                setNewEntries([]);
                return;
            }

            let isJSON = false;
            let data = [];

            try {
                const jsonData = JSON.parse(importText);
                isJSON = true;
                data = jsonData;
            } catch {
                isJSON = false;
            }

            if (isJSON) {
                setImporttype('json');
                const requiredAttributes = ["id", "code", "name", "incomeaccountid", "type", "posvisible", "unitofmeasurement", "pricing"];
                const isValidData = data.every(entry =>
                    requiredAttributes.every(attr => entry.hasOwnProperty(attr))
                );

                if (isValidData) {
                    const newEntries = data.filter(entry => {
                        return !project.items.some(item => item.id === entry.id);
                    });

                    if (newEntries.length > 0) {
                        setNewEntries(newEntries);
                        setResult('Data is valid. New entries found: ' + newEntries.length);
                    }
                    else {
                        setResult(data.length + " entries found. No new data.");
                    }
                }
                else {
                    setResult('Invalid data: Missing required attributes.');
                }
            }

            if (!isJSON) {

            }
        }, [importText]);

        const handleImport = () => {
            console.log('Trying to import data');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'add',
                project.archived
            );
            if (hasPermission.code == 0) {
                setResult(hasPermission.data);
                return;
            }

            if (newEntries.length == 0) {
                setResult('No new entries to import');
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                items: newEntries,
                type: importType
            }

            axios.post(configData.CONTROLLERURL + configData.IMPORTITEMS, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Import data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'IMPORT_ITEMS',
                            items: newEntries
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data);
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });

            setResult('Data imported successfully.');
        };

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <textarea
                                className='modal_textarea'
                                value={importText}
                                onChange={e => setImportText(e.target.value)}
                                placeholder="Paste your import data here..."
                                rows={10}
                                cols={50}
                                style={{ resize: 'vertical' }}
                            />
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleImport} disabled={loading}>{loading ? 'Loading...' : 'Import'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function Pricing({ price, index, handleNameChangePricing, handleAmountChangePricing, handleCurrencyChangePricing, handleRemovePricing }) {
        return (
            <tr>
                <td>
                    <input
                        className='modal_input'
                        type="text"
                        placeholder='Name'
                        value={price.pricename}
                        onChange={(e) => handleNameChangePricing(e, index)}
                    />
                </td>
                <td>
                    <input
                        className='modal_input'
                        type="number"
                        placeholder={0}
                        value={price.priceamount}
                        onChange={(e) => handleAmountChangePricing(e, index)}
                    />
                </td>
                <td>
                    <Select data={project.currencies} itemid={price.pricecurrencyid} setItemid={(accountId) => handleCurrencyChangePricing({ target: { value: accountId } }, index)} />
                </td>
                <td>
                    <div className='modal_removeitembutton' onClick={() => handleRemovePricing(index)}>&minus;</div>
                </td>
            </tr>
        );
    }

    function AddItem() {
        const [code, setCode] = useState('');
        const [name, setName] = useState('');
        const [incomeaccountid, setIncomeaccountid] = useState('');
        const [pricing, setPricing] = useState([]);
        const [taxid, setTaxid] = useState('');
        const [type, setType] = useState('');
        const [categoryid, setCategoryid] = useState('');
        const [posvisible, setPosvisible] = useState(false);
        const [unitofmeasurement, setUnitofmeasurement] = useState('unit');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        const handleAddPricing = () => {
            setPricing([...pricing, { pricename: '', priceamount: '', pricecurrencyid: '' }]);
        };

        const handleNameChangePricing = (e, index) => {
            const newPricing = [...pricing];
            newPricing[index].pricename = e.target.value;
            setPricing(newPricing);
        };

        const handleAmountChangePricing = (e, index) => {
            const newPricing = [...pricing];
            newPricing[index].priceamount = e.target.value;
            setPricing(newPricing);
        };

        const handleCurrencyChangePricing = (e, index) => {
            const newPricing = [...pricing];
            newPricing[index].pricecurrencyid = e.target.value;
            setPricing(newPricing);
        };

        const handleRemovePricing = (index) => {
            const newPricing = [...pricing];
            newPricing.splice(index, 1);
            setPricing(newPricing);
        };

        const addItem = () => {
            console.log('Trying to add item');

            if (!name) {
                setResult('Missing info')
                return
            }

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'add',
                project.archived
            );
            if (hasPermission.code == 0) {
                setResult(hasPermission.data);
                return;
            }

            if (project.items.length > 1000) {
                setResult('Exceeded limit, please use the POS module.');
                return;
            }

            const trimmedName = name.trim();

            const isNameDuplicate = project.items.some(item => item.name === trimmedName);
            if (isNameDuplicate) {
                setResult('Item with the same name already exists');
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                code: code,
                name: trimmedName,
                incomeaccountid: incomeaccountid,
                taxid: taxid,
                type: type,
                categoryid: categoryid,
                posvisible: posvisible,
                unitofmeasurement: unitofmeasurement,
                pricing: pricing,
            }

            axios.post(configData.CONTROLLERURL + configData.ADDITEM, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Add item data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        data.id = res.data.id;
                        dispatch({
                            type: 'ADD_ITEM',
                            item: data
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error')
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Code</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Income Account</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.incomeaccounts} itemid={incomeaccountid} setItemid={setIncomeaccountid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Tax</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.taxes} itemid={taxid} setItemid={setTaxid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Type</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={itemtypes} itemid={type} setItemid={setType} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Category</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.itemscategories} itemid={categoryid} setItemid={setCategoryid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>POS Visible</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                type="checkbox"
                                checked={posvisible}
                                onChange={(e) => setPosvisible(e.target.checked)}
                                className='modal_checkbox'
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Unit of measurement</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={unitsofmeasurement} itemid={unitofmeasurement} setItemid={setUnitofmeasurement} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Pricing</div>
                        </div>
                    </div>
                    <div className='modal_row'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Price</th>
                                    <th>Currency</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    pricing.length ?
                                        pricing.map((price, index) => (
                                            <Pricing
                                                key={index}
                                                price={price}
                                                index={index}
                                                handleNameChangePricing={handleNameChangePricing}
                                                handleAmountChangePricing={handleAmountChangePricing}
                                                handleCurrencyChangePricing={handleCurrencyChangePricing}
                                                handleRemovePricing={handleRemovePricing}
                                            />
                                        ))
                                        :
                                        <tr><td colSpan={4}>No pricing</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='modal_actions'>
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={handleAddPricing}>Add Pricing</button>
                            </div>
                            <div className='modal_buttoncontainer'></div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => addItem()} disabled={loading}>{loading ? 'Loading...' : 'Save'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function EditItem({ item }) {
        const [id, setId] = useState('');
        const [code, setCode] = useState('');
        const [name, setName] = useState('');
        const [incomeaccountid, setIncomeaccountid] = useState('');
        const [taxid, setTaxid] = useState('');
        const [pricing, setPricing] = useState([]);
        const [type, setType] = useState('');
        const [categoryid, setCategoryid] = useState('');
        const [posvisible, setPosvisible] = useState(false);
        const [unitofmeasurement, setUnitofmeasurement] = useState('pcs');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            setId(item.id);
            setCode(item.code);
            setName(item.name);
            setIncomeaccountid(item.incomeaccountid);
            setTaxid(item.taxid);
            setType(item.type)
            setCategoryid(item.categoryid)
            setPosvisible(item.posvisible)
            setPricing(item.pricing)
            setUnitofmeasurement(item.unitofmeasurement)
        }, [item]);

        const handleAddPricing = () => {
            setPricing([...pricing, { pricename: '', priceamount: '', pricecurrencyid: '' }]);
        };

        const handleNameChangePricing = (e, index) => {
            const newPricing = [...pricing];
            newPricing[index].pricename = e.target.value;
            setPricing(newPricing);
        };

        const handleAmountChangePricing = (e, index) => {
            const newPricing = [...pricing];
            newPricing[index].priceamount = e.target.value;
            setPricing(newPricing);
        };

        const handleCurrencyChangePricing = (e, index) => {
            const newPricing = [...pricing];
            newPricing[index].pricecurrencyid = e.target.value;
            setPricing(newPricing);
        };

        const handleRemovePricing = (index) => {
            const newPricing = [...pricing];
            newPricing.splice(index, 1);
            setPricing(newPricing);
        };

        const updateItem = () => {
            console.log('Trying to update item');

            if (!name) {
                setResult('Missing info')
                return
            }

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'update',
                project.archived
            );
            if (hasPermission.code == 0) {
                setResult(hasPermission.data);
                return;
            }

            const trimmedName = name.trim();

            const isNameDuplicate = project.items.some(item => item.name === trimmedName && item.id !== id);
            if (isNameDuplicate) {
                setResult('Item with the same name already exists');
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
                code: code,
                name: trimmedName,
                incomeaccountid: incomeaccountid,
                taxid: taxid,
                type: type,
                categoryid: categoryid,
                posvisible: posvisible,
                unitofmeasurement: unitofmeasurement,
                pricing: pricing,
            }

            axios.post(configData.CONTROLLERURL + configData.UPDATEITEM, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Update item data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'UPDATE_ITEM',
                            item: data
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error')
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Code</div>
                        </div>
                        <div className='modal_rowsection'>
                            <div className='modal_row'>
                                <input
                                    className='modal_input'
                                    type="text"
                                    placeholder="Code"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Amount"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Income Account</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.incomeaccounts} itemid={incomeaccountid} setItemid={setIncomeaccountid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Tax</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.taxes} itemid={taxid} setItemid={setTaxid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Type</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={itemtypes} itemid={type} setItemid={setType} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Category</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.itemscategories} itemid={categoryid} setItemid={setCategoryid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>POS Visible</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                type="checkbox"
                                checked={posvisible}
                                onChange={(e) => setPosvisible(e.target.checked)}
                                className='modal_checkbox'
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Unit of measurement</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={unitsofmeasurement} itemid={unitofmeasurement} setItemid={setUnitofmeasurement} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Pricing</div>
                        </div>
                    </div>
                    <div className='modal_row'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Price</th>
                                    <th>Currency</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    pricing.length ?
                                        pricing.map((price, index) => (
                                            <Pricing
                                                key={index}
                                                price={price}
                                                index={index}
                                                handleNameChangePricing={handleNameChangePricing}
                                                handleAmountChangePricing={handleAmountChangePricing}
                                                handleCurrencyChangePricing={handleCurrencyChangePricing}
                                                handleRemovePricing={handleRemovePricing}
                                            />
                                        ))
                                        :
                                        <tr><td colSpan={4}>No pricing</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='modal_actions'>
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={handleAddPricing}>Add Pricing</button>
                            </div>
                            <div className='modal_buttoncontainer'></div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => updateItem()} disabled={loading}>{loading ? 'Loading...' : 'Update'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => removeButton(item)}>Remove</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function RemoveItem({ item }) {
        const [id, setId] = useState('');
        const [code, setCode] = useState('');
        const [name, setName] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            setId(item.id);
            setCode(item.code);
            setName(item.name);
        }, [item]);

        const removeItem = () => {
            console.log('Trying to remove item');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'remove',
                project.archived
            );
            if (hasPermission.code == 0) {
                setResult(hasPermission.data);
                return;
            }

            if (project.salesinvoices) {
                const hasSalesInvoiceData = project.salesinvoices.some((invoice) => {
                    return invoice.items && invoice.items.some((item) => item.itemid === id);
                });
                if (hasSalesInvoiceData) {
                    setResult('Project has sales invoice data related to ' + name);
                    return;
                }
            }

            if (project.purchaseinvoices) {
                const hasPurchaseInvoicesData = project.purchaseinvoices.some((invoice) => {
                    return invoice.items && invoice.items.some((item) => item.itemid === id);
                });
                if (hasPurchaseInvoicesData) {
                    setResult('Project has purchase invoice data related to ' + name);
                    return;
                }
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id
            }

            axios.post(configData.CONTROLLERURL + configData.REMOVEITEM, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Remove item data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'REMOVE_ITEM',
                            itemid: id
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error')
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_actions'>
                        {result && <div className='modal_result'>{result}</div>}
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={() => removeItem()} disabled={loading}>{loading ? 'Loading...' : 'Remove'}</button>
                            </div>
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const ViewItem = ({ item }) => {
        const [id, setId] = useState('');
        const [name, setName] = useState('');
        const [pricing, setPricing] = useState([]);

        const printRef = useRef();

        useEffect(() => {
            setId(item.id);
            setName(item.name);
            setPricing(item.pricing)
        }, [item]);

        return (
            <div className='modal_body'>
                <div className='modal_printable' ref={printRef}>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Project Name</div>
                        </div>
                        <div className='modal_rowsection'>{project.name}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>ID</div>
                        </div>
                        <div className='modal_rowsection'>{id}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>{name}</div>
                    </div>
                    <div className='modal_row'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Price</th>
                                    <th>Currency</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    pricing.length ?
                                        pricing.map((price, index) => {
                                            let currencySymbol = project.currencies.find(cur => cur.id == price.pricecurrencyid)?.symbol || '';
                                            return (
                                                <tr key={'price' + index}>
                                                    <td>{price.pricename}</td>
                                                    <td>{price.priceamount}</td>
                                                    <td>{currencySymbol}</td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr><td colSpan={4}>No pricing</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<button className="modal_button">Print</button>)}
                                content={() => printRef.current}
                            />
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    function ViewCategories() {
        const [categories, setCategories] = useState([]);

        const [id, setId] = useState('');
        const [orderid, setOrderid] = useState('');
        const [name, setName] = useState('');

        const [result, setResult] = useState('');
        const [loading, setLoading] = useState(false);

        const printRef = useRef();

        useEffect(() => {
            setCategories(project.itemscategories);
        }, [project.itemscategories]);

        const editItemCategory = (category) => {
            setId(category.id)
            setOrderid(category.orderid)
            setName(category.name)
        }

        const handleAddCategory = () => {
            setCategories([...categories, { id: '', orderid: '', name: '' }])
        }

        const handleCancel = (index) => {
            setCategories(categories.filter((_, i) => i !== index));
        };

        const addCategory = () => {
            console.log('Trying to add category');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'add',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            if (!name) {
                setResult('Missing data');
                return;
            }

            const trimmedName = name.trim();

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                orderid: orderid,
                name: trimmedName,
            }

            axios.post(configData.CONTROLLERURL + configData.ADDITEMCATEGORY, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Add category data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'ADD_ITEMCATEGORY',
                            itemcategory: data
                        });
                        setId('')
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        const updateCategory = () => {
            console.log('Trying to update category');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'update',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            if (!name) {
                setResult('Missing data');
                return;
            }

            const trimmedName = name.trim();

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
                orderid: orderid,
                name: trimmedName,
            }

            axios.post(configData.CONTROLLERURL + configData.UPDATEITEMCATEGORY, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Update category data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'UPDATE_ITEMCATEGORY',
                            itemcategory: data
                        });
                        setId('')
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        const handleRemoveCategory = (id) => {
            console.log('Trying to remove category');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'remove',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
            }

            axios.post(configData.CONTROLLERURL + configData.REMOVEITEMCATEGORY, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Remove category data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'REMOVE_ITEMCATEGORY',
                            itemcategoryid: data
                        });
                        setId('')
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable' ref={printRef}>
                    <div className='modal_row'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Orderid</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    categories.map((category, index) => {
                                        if (category.id === id) {
                                            return (
                                                <tr key={'category' + index}>
                                                    <td>
                                                        {
                                                            category.id ?
                                                                <>
                                                                    <div className='table_button' onClick={() => updateCategory()}>Update</div>
                                                                    <div className='table_button' onClick={() => handleRemoveCategory(category.id)}>Remove</div>
                                                                </>
                                                                :
                                                                <>
                                                                    <div className='table_button' onClick={() => addCategory()}>Add</div>
                                                                    <div className='table_button' onClick={() => handleCancel(index)}>Cancel</div>
                                                                </>
                                                        }
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <input
                                                                type="text"
                                                                value={orderid}
                                                                onChange={(e) => setOrderid(e.target.value)}
                                                                className="modal_input"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <input
                                                                type="text"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value)}
                                                                className="modal_input"
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        else {
                                            return (
                                                <tr key={'category' + index} onClick={() => editItemCategory(category)}>
                                                    <td>{category.id}</td>
                                                    <td>{category.orderid}</td>
                                                    <td>{category.name}</td>
                                                </tr>
                                            )
                                        }
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleAddCategory}>Add Category</button>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<button className="modal_button">Print</button>)}
                                content={() => printRef.current}
                            />
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    function ViewModifiers() {
        const [modifiers, setModifiers] = useState([]);
        const [id, setId] = useState('');
        const [orderid, setOrderid] = useState('');
        const [name, setName] = useState('');
        const [price, setPrice] = useState('');
        const [currencyid, setCurrencyid] = useState('');

        const [result, setResult] = useState('');
        const [loading, setLoading] = useState(false);

        const printRef = useRef();

        useEffect(() => {
            setModifiers(project.itemsmodifiers);
        }, [project.itemsmodifiers]);

        const editItemModifier = (modifier) => {
            setId(modifier.id)
            setName(modifier.name)
        }

        const handleAddModifier = () => {
            setModifiers([...modifiers, { id: '', name: '', price: '', currencyid: '' }])
        }

        const handleCancelModifier = (index) => {
            setModifiers(modifiers.filter((_, i) => i !== index));
        };

        const addModifier = () => {
            console.log('Trying to add modifier');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'add',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            if (!name) {
                setResult('Missing data');
                return;
            }

            const trimmedName = name.trim();

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                name: trimmedName,
                price: price,
                currencyid: currencyid,
            }

            axios.post(configData.CONTROLLERURL + configData.ADDITEMMODIFIER, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Add modifier data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'ADD_ITEMMODIFIER',
                            itemcategory: data
                        });
                        setId('')
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        const updateModifier = () => {
            console.log('Trying to update modifier');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'update',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            if (!name) {
                setResult('Missing data');
                return;
            }

            const trimmedName = name.trim();

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
                name: trimmedName,
                price: price,
                currencyid: currencyid,
            }

            axios.post(configData.CONTROLLERURL + configData.UPDATEITEMMODIFIER, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Update modifier data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'UPDATE_ITEMMODIFIER',
                            modifier: data
                        });
                        setId('')
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        const removeModifier = (id) => {
            console.log('Trying to remove modifier');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Items',
                'remove',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
            }

            axios.post(configData.CONTROLLERURL + configData.REMOVEITEMMODIFIER, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Remove modifier data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'REMOVE_ITEMMODIFIER',
                            itemcategoryid: data
                        });
                        setId('')
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable' ref={printRef}>
                    <div className='modal_row'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    modifiers.map((modifier, index) => {
                                        if (modifier.id === id) {
                                            return (
                                                <tr key={'modifier' + index}>
                                                    <td>
                                                        {
                                                            modifier.id ?
                                                                <>
                                                                    <div className='table_button' onClick={() => updateModifier()}>Update</div>
                                                                    <div className='table_button' onClick={() => removeModifier(modifier.id)}>Remove</div>
                                                                </>
                                                                :
                                                                <>
                                                                    <div className='table_button' onClick={() => addModifier()}>Add</div>
                                                                    <div className='table_button' onClick={() => handleCancelModifier(index)}>Cancel</div>
                                                                </>
                                                        }
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <input
                                                                type="text"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value)}
                                                                className="modal_input"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <input
                                                                type="text"
                                                                value={price}
                                                                onChange={(e) => setPrice(e.target.value)}
                                                                className="modal_input"
                                                            />
                                                            <Select data={project.currencies} itemid={currencyid} setItemid={setCurrencyid} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        else {
                                            return (
                                                <tr key={'category' + index} onClick={() => editItemModifier(modifier)}>
                                                    <td>{modifier.id}</td>
                                                    <td>{modifier.name}</td>
                                                    <td>{modifier.currencyid + ' ' + modifier.price}</td>
                                                </tr>
                                            )
                                        }
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleAddModifier}>Add Modifier</button>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<button className="modal_button">Print</button>)}
                                content={() => printRef.current}
                            />
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='accounts'>
            <Title text='Items' />

            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={addButton}>New Item</button>
                </div>
                <div className='buttonsection'>
                    <input
                        className='input'
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <div className='buttonsection'></div>
            </div>

            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={viewCategories}>Categories</button>
                </div>
                <div className='buttonsection'>
                    <button className='button' onClick={viewModifiers}>Modifiers</button>
                </div>
            </div>

            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={exportPage}>Export</button>
                </div>
                <div className='buttonsection'>
                    <button className='button' onClick={importPage}>Import</button>
                </div>
            </div>

            <table className='table'>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th>Code</th>
                        <th>Name</th>
                        <th>Balance</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        filtereditems.map((item, index) => (
                            <tr key={'item' + index}>
                                <td><div className='table_button' onClick={() => editButton(item)}>Edit</div></td>
                                <td><div className='table_button' onClick={() => viewButton(item)}>View</div></td>
                                <td><div>{item.code}</div></td>
                                <td><div>{item.name}</div></td>
                                <td>
                                    <div
                                        className='items_balance'
                                        onClick={() =>
                                            handleAccountStatement(
                                                'items',
                                                {
                                                    id: item.id,
                                                    name: item.name,
                                                    from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                    to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                    subaccountid: '',
                                                    currencyid: project.basecurrency
                                                }
                                            )}
                                    >
                                        {getQuantity(
                                            {
                                                salesinvoices: project.salesinvoices,
                                                purchaseinvoices: project.purchaseinvoices,
                                                productionorders: project.productionorders
                                            },
                                            item.id)
                                        }
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    );
}

export default Items;